import { useCallback } from 'react'
import axios from 'axios'
import { getServerHost } from '../utils/get-server-host'
import { UserId } from '../types/types'
import { getHeaders } from '../utils/get-headers'
import { useSetRecoilState } from 'recoil'
import { userState } from '../states/user-state'

interface Options {
  userId?: UserId
}

export const useUpdateUser = (options: Options) => {
  const { userId } = options
  const set = useSetRecoilState(userState(userId))

  return useCallback(
    async (data) => {
      if (!userId) {
        return
      }

      try {
        const response = await axios.put(getServerHost(`user/${userId}`), data, {
          headers: getHeaders(),
        })

        set(response.data.user)
      } catch (e) {
        return e
      }
    },
    [userId],
  )
}